import { inject, Injectable } from '@angular/core';
import { componentsToLoad } from '@shared/services/component-loader/config';
import { LogsService } from '@shared/services/logs';

@Injectable({
  providedIn: 'root',
})
export class ComponentRegistryService {
  private readonly components = new Map<string, unknown>();
  private readonly logs = inject(LogsService);

  constructor() {
    this.initializeComponents();
  }

  getComponentByType(type: string): unknown {
    const component = this.components.get(type);
    const componentName = (component as { name: string })?.name;
    if (!component) {
      this.logs.error('ComponentRegistryService', `Component of type "${type}" not found`);
    } else {
      this.logs.trace('ComponentRegistryService', `Getting component of type "${type}" (name: ${componentName})`);
    }
    return component;
  }

  private initializeComponents(): void {
    componentsToLoad.forEach(({ type, component }) => {
      this.components.set(type, component);
    });
  }
}
